<!-- =========================================================================================
	File Name: ECommerceCheckout.vue
	Description: eCommerce Checkout page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="ecommerce-checkout-demo">
        <form-wizard
            ref="checkoutWizard"
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            :hide-buttons="false">

            <!-- tab 1 content -->
            <tab-content title="Dados" icon="feather icon-home" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" >

                    <!-- LEFT COL -->
                    <vx-card class="list-view-item mb-base overflow-hidden">


                      <div class="vx-row">
                        <div class="vx-col w-1/3">
                            <vs-input name="nome_cliente" v-model.lazy="nome_cliente" label="Nome do Cliente" class="w-full" />
                        </div>
                        <div class="vx-col w-1/3">
                            <vs-input name="data_nascimento" v-mask="'##/##/####'" v-model.lazy="data_nascimento"  label="Data de Nascimento" class="w-full" />
                        </div>
                        <div class="vx-col w-1/3">
                            <vs-select v-model="sexo" class="w-full select-large" label="Sexo">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in sexos" class="w-full" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-1/4 mt-5">
                            <vs-input label="CPF" v-mask="'###.###.###-##'" v-model="cpf" class="w-full" />
                        </div>

                        <div class="vx-col w-1/4 mt-5">
                            <vs-input label="Telefone" v-mask="'(##) #####-####'" v-model="telefone" class="w-full" />
                        </div>

                        <div class="vx-col w-1/2 mt-5">
                            <vs-input label="Email" v-model="email" class="w-full" />
                        </div>

                        <div class="vx-col w-1/4 mt-5">
                            <vs-input v-mask="'#####-###'" @blur="getcep(cep)" type="text" label="CEP"  v-model="cep" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Lagradouro"  v-model="endereco" class="w-full" />
                        </div>
                        <div class="vx-col w-1/4 mt-5">
                            <vs-input type="text" label="Número"  v-model="numero" class="w-full" />
                        </div>
                        <div class="vx-col w-full mt-5">
                            <vs-input type="text" label="Complemento"  v-model="complemento" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Cidade"  v-model="cidade" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Bairro"  v-model="bairro" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="UF"  v-model="estado" class="w-full" />
                        </div>

                      </div>


                    </vx-card>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card>


                            <p class="font-semibold mb-3">Informações do Produto</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Nome</span>
                                <span>{{seguro.seguro}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Franquia</span>
                                <span class="text-success">{{franquia.nome_franquia}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Valor</span>
                                <span class="text-success">R$ {{franquia.price_operador}}</span>
                            </div>

                            <vs-divider />


                            <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">CONTINUAR</vs-button>
                        </vx-card>
                    </div>
                </div>


            </tab-content>

            <!-- tab 2 content -->


            <!-- tab 3 content -->
            <tab-content title="Pagamento" icon="feather icon-credit-card" class="mb-5">

                <div class="vx-row">

                    <!-- LEFT COL: PAYMENT OPTIONS -->
                    <div class="vx-col lg:w-2/3 w-full">
                        <vx-card title="Formas de Pagamento" subtitle="Selecione a opção correta">

                            <div class="mt-3">
                                <ul>
                                  <!-- OPTION 1 -->
                                  <li>
                                    <!-- CARD DETAILS -->
                                    <div class="flex flex-wrap justify-between items-center">
                                        <vs-radio v-model="paymentMethod" vs-value="debit-card">
                                            <div class="flex items-center">
                                                <img src="https://www.adiq.com.br/static/logo-6c8a8337b1a1e6b71cd64a73f0da2f85.png" alt="bank-logo" height="40" width="50" class="inline-flex">
                                                <span>  Cartão de Crédito</span>
                                            </div>
                                        </vs-radio>
                                    </div>

                                    <!-- CVV BLOCK -->
                                    <form data-vv-scope="cvv-form" class="mt-4">
                                        <div class="flex items-center">
                                          <div class="vx-row">
                                              <div class="vx-col w-1/2 mt-5">
                                                  <vs-input type="card" v-mask="'#### #### #### ####'" label="Cartão"  v-model="cc" class="w-full" />
                                              </div>
                                              <div class="vx-col w-1/4 mt-5">
                                                  <vs-input type="text" v-mask="'##/##'" label="Vencimento"  v-model="cv" class="w-full" />
                                              </div>
                                              <div class="vx-col w-1/4 mt-5">
                                                  <vs-input type="text" v-mask="'###'" label="CVV"  v-model="cvv" class="w-full" />
                                              </div>
                                              <div class="vx-col w-1/2 mt-5">
                                                  <vs-button @click.prevent="makePayment" :disabled="false">FINALIZAR</vs-button>
                                              </div>
                                          </div>


                                        </div>

                                        <span v-show="errors.has('cvv-form.cvv')" class="text-danger ml-24">{{ errors.first('cvv-form.cvv') }}</span>
                                    </form>
                                  </li>



                                </ul>


                            </div>
                        </vx-card>
                    </div>

                    <!-- RIGHT COL: PRICE -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card title="Informações do Pagamento">

                            <div class="flex justify-between mb-2">
                                <span>Pagamento Total</span>
                                <span class="font-semibold">R$ {{franquia.price_operador}}</span>
                            </div>

                        </vx-card>
                    </div>
                </div>
            </tab-content>

        </form-wizard>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {VMoney} from 'v-money'
import {mask} from 'vue-the-mask'
//const ItemListView = () => import('./components/ItemListView.vue')
var assert = require('assert')


export default {
    data() {
        return {

            // TAB 2
            nome_cliente: "",
            data_nascimento: "",
            sexo: "",
            cep: "",
            endereco: "",
            nome_franquia: "",
            complemento: "",
            numero: "",
            estado: "",
            bairro: "",
            cidade: "",
            pincode: "",
            cpf: "",
            telefone: "",
            email: "",
            cc: "",
            cv: "",
            cvv: "",
            bruto: 0,
            addressType: 1,
            franquia: [],
            produto: [],
            seguro: [],
            sexos: [
                { text: 'Masculino', value: 'Masculino' },
                { text: 'Feminino', value: 'Feminino' },
            ],
            money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              suffix: '',
              precision: 2,
              masked: false /* doesn't work with directive */
            },

            // TAB 3
            paymentMethod: "debit-card",
            cvv: '',
        }
    },
    computed: {
        lucro_mes() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);

            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;

            return this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        lucro_ano() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);

            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;
            return this.roundToXDigits(this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        lucro_bruto() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);

            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;
            this.bruto = this.roundToXDigits(this.parseNumber(this.invest)+this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            return this.roundToXDigits(this.parseNumber(this.invest)+this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        cartItems() {
            return this.$store.state.p2p.cartItems.slice().reverse();
        },
        isInWishList() {
            return (itemId) => this.$store.getters['p2p/isInWishList'](itemId)
        },
    },
    methods: {

      getcep(name)
      {
        fetch('http://viacep.com.br/ws/' + this.cep + '/json/', {
          method: 'GET',
          headers: { 'Accept': 'application/json'}
        })
        .then((response) => response.text())
        .then((responseData) => {

          var dados = JSON.parse(responseData);
          if(!dados.uf)
          {
            return this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: 'CEP Invalido',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
          }
          this.endereco = dados.logradouro;
          this.cidade = dados.localidade;
          this.complemento = dados.complemento
          this.bairro = dados.bairro;
          this.estado = dados.uf;
        })
        .catch((error) => {
          this.$vs.notify({
                      time: 2500,
                      title: 'Error',
                      text: 'CEP Invalido',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                  });
        });
      },

        // TAB 1
        calcParcelaJuros(valor_total, parcelas,juros){
            var valor = 0;
            for(var i=1;i<(parcelas+1);i++){
                var I =juros/100.00;
                var valor_parcela = valor_total*I*Math.pow((1+I),parcelas)/(Math.pow((1+I),parcelas)-1);
                valor+=valor_parcela;
            }
            return valor;
        },
        juros_simples(capital, taxa, n_periodos) {
            return capital * taxa * n_periodos;
        },
        roundToXDigits(value, digits)
        {
          if (!digits) {
            digits = 2;
          }

          value = value * Math.pow(10, digits);
          value = Math.round(value);
          value = value / Math.pow(10, digits);

          return value;
        },
        parseNumber(strg) {
          var strg = strg || "";
          var decimal = '.';
          strg = strg.replace(/[^0-9$.,]/g, '');
          strg = strg.replace('R', '');
          strg = strg.replace('$', '');
          strg = strg.replace(' ', '');
          if(strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
          if((strg.match(new RegExp("\\" + decimal,"g")) || []).length > 1) decimal="";
          if (decimal != "" && (strg.length - strg.indexOf(decimal) - 1 == 3) && strg.indexOf("0" + decimal)!==0) decimal = "";
          strg = strg.replace(new RegExp("[^0-9$" + decimal + "]","g"), "");
          strg = strg.replace(',', '.');
          return parseFloat(strg);
        },
        removeItemFromCart(item) {
            this.$store.dispatch('p2p/toggleItemInCart', item)
        },
        wishListButtonClicked(item) {
            // Toggle in Wish List
            if (this.isInWishList(item.objectID)) this.$router.push('/apps/eCommerce/wish-list')
            else {
                this.toggleItemInWishList(item)
                this.removeItemFromCart(item)
            }
        },
        toggleItemInWishList(item) {
            this.$store.dispatch('p2p/toggleItemInWishList', item)
        },
        updateItemQuantity(event, index) {
            const itemIndex = Math.abs(index + 1 - this.cartItems.length)
            this.$store.dispatch("p2p/updateItemQuantity", { quantity: event, index: itemIndex })
        },
        updateItemInvest(event, index) {
            const itemIndex = Math.abs(index + 1 - this.cartItems.length)
            this.$store.dispatch("p2p/updateItemInvest", { invest: event, index: itemIndex })
        },

        // TAB 2
        submitNewAddressForm() {
            return new Promise(() => {
                this.$validator.validateAll('add-new-address').then(result => {
                    if (result) {
                        // if form have no errors
                        this.$refs.checkoutWizard.nextTab()
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Please enter valid details',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    }
                })
            })
        },

        // TAB 3
        makePayment() {
            return new Promise(() => {
                this.$validator.validateAll('cvv-form').then(result => {
                    if (result) {
                        this.$vs.loading({
                          type:'radius',
                        })
                        // if form have no errors this.roundToXDigits(this.parseNumber(this.invest), 2)
                        fetch(this.$store.state.API_URL + 'Operador/Cadastro/Usuario', {
                            method: 'POST',
                            headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: "token="+localStorage.getItem("token")+"&nome_cliente="+this.nome_cliente+"&data_nascimento="+this.data_nascimento+"&sexo="+this.sexo+"&cpf="+this.cpf+"&telefone="+this.telefone+"&email="+this.email+"&cep="+this.cep+"&endereco="+this.endereco+"&numero="+this.numero+"&complemento="+this.complemento+"&cidade="+this.cidade+"&bairro="+this.bairro+"&estado="+this.estado+"&cc="+this.cc+"&cv="+this.cv+"&cvv="+this.cvv
                        })
                        .then((response) => response.text())
                        .then((responseData) => {
                            this.$vs.loading.close();

                            var dados = JSON.parse(responseData);

                            if(dados.done == true)
                            {
                                this.$vs.notify({
                                    title: 'Venda',
                                    text: dados.message,
                                    color: 'success',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-circle'
                                })
                            }
                            else
                            {
                                this.$vs.notify({
                                    title: 'Error',
                                    text: dados.message,
                                    color: 'danger',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-circle'
                                })
                            }

                        })
                        .catch((error) => {
                          this.$vs.loading.close();
                          this.$vs.notify({
                              title: 'Error',
                              text: 'Tente novamente mais tarde!',
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          })
                        })

                    } else {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Digite o PIN',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    }
                })
            })
        }
    },
    created() {
        const thisIns = this;
        fetch(this.$store.state.API_URL + 'Info/Home', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
            body: "token="+localStorage.getItem("token")
        })
        .then((response) => response.text())
        .then((responseData) => {

            var dados = JSON.parse(responseData);
            thisIns.saldo = dados.meus_dados.saldo;
            thisIns.franquia = dados.meus_dados.franquia;
            thisIns.produto = dados.meus_dados.produto;
            thisIns.seguro = dados.meus_dados.seguro;

        });
      },
    components: {
        //ItemListView,
        FormWizard,
        TabContent
    },
    directives: {money: VMoney, mask}
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        /deep/ .wizard-header {
            padding: 0;
        }

        /deep/ .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
        }
    }
    .list-view-item {
        .item-name, .item-description {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .item-name {
            -webkit-line-clamp: 2;
        }

        .item-description {
            -webkit-line-clamp: 5;
        }

        .grid-view-img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            transition: .35s;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

            .grid-view-img{
                opacity: 0.9;
            }
        }
    }
}
</style>
